module.exports = __webpack_public_path__ + "img/tramway_lego.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tramway_lego.jpg
// module id = 5
// module chunks = 0